/**
 * PdfReportService - Generador de Diplomas e Informes PDF Imprimibles
 * Detectimáticas - LOMLOE / ABN
 */

class PdfReportServiceManager {
    /**
     * Cargar jsPDF dinámicamente si no está en window
     */
    async getJsPDF() {
        if (window.jspdf && window.jspdf.jsPDF) {
            return window.jspdf.jsPDF;
        }
        if (window.jsPDF) {
            return window.jsPDF;
        }
        try {
            const module = await import('jspdf');
            return module.jsPDF || module.default;
        } catch (err) {
            console.error('❌ Error cargando jsPDF:', err);
            throw new Error('No se pudo cargar la librería PDF');
        }
    }

    /**
     * Generar y descargar el Diploma Oficial de Detective Matemático
     * @param {string} studentName 
     * @param {number} badgesCount 
     */
    async generateDiploma(studentName = 'Detective Jr.', badgesCount = 5) {
        try {
            const JSpdf = await this.getJsPDF();
            const doc = new JSpdf({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            const width = doc.internal.pageSize.getWidth();
            const height = doc.internal.pageSize.getHeight();

            // Marco Exterior Azul Oscuro
            doc.setLineWidth(4);
            doc.setDrawColor(30, 58, 138); // #1e3a8a
            doc.rect(10, 10, width - 20, height - 20);

            // Marco Interior Dorado
            doc.setLineWidth(1.5);
            doc.setDrawColor(217, 119, 6); // #d97706
            doc.rect(14, 14, width - 28, height - 28);

            // Título Principal
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(32);
            doc.setTextColor(30, 58, 138);
            doc.text('DIPLOMA DE DETECTIVE MATEMÁTICO', width / 2, 45, { align: 'center' });

            // Subtítulo
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(16);
            doc.setTextColor(71, 85, 105);
            doc.text('Se otorga el presente reconocimiento oficial a:', width / 2, 65, { align: 'center' });

            // Nombre del Alumno
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(28);
            doc.setTextColor(217, 119, 6);
            doc.text(studentName.toUpperCase(), width / 2, 88, { align: 'center' });

            // Línea decorativa bajo el nombre
            doc.setLineWidth(0.8);
            doc.setDrawColor(217, 119, 6);
            doc.line((width / 2) - 60, 93, (width / 2) + 60, 93);

            // Texto de Logros
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(14);
            doc.setTextColor(30, 41, 59);
            const bodyText = `Por demostrar una brillante capacidad de razonamiento lógico, resolución de problemas ABN y pensamiento computacional, habiendo superado con éxito las investigaciones de Detectimáticas y conseguido ${badgesCount} insignias oficiales.`;
            
            const splitText = doc.splitTextToSize(bodyText, width - 80);
            doc.text(splitText, width / 2, 115, { align: 'center' });

            // Sello de la Agencia
            doc.setFillColor(254, 243, 199);
            doc.circle(55, 165, 18, 'F');
            doc.setLineWidth(1);
            doc.setDrawColor(217, 119, 6);
            doc.circle(55, 165, 18, 'S');

            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(180, 83, 9);
            doc.text('AGENCIA DE', 55, 162, { align: 'center' });
            doc.text('DETECTIVES', 55, 167, { align: 'center' });
            doc.text('★ LOMLOE ★', 55, 172, { align: 'center' });

            // Fecha y Firma
            const dateStr = new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(12);
            doc.setTextColor(71, 85, 105);
            doc.text(`Fecha: ${dateStr}`, width - 75, 162, { align: 'center' });

            doc.setLineWidth(0.5);
            doc.line(width - 105, 170, width - 45, 170);
            doc.setFontSize(10);
            doc.text('Firma del Detective Mentor', width - 75, 176, { align: 'center' });

            // Guardar PDF
            const safeName = studentName.replace(/[/\\?%*:|"<>]/g, '_').replace(/\s+/g, '_');
            doc.save(`Diploma_Detective_${safeName}.pdf`);
            console.log('📄 Diploma PDF generado con éxito');
            return true;
        } catch (err) {
            console.error('❌ Error generando Diploma PDF:', err);
            return false;
        }
    }
}

export const PdfReportService = new PdfReportServiceManager();

if (typeof window !== 'undefined') {
    window.Detectimaticas = window.Detectimaticas || {};
    window.Detectimaticas.PdfReportService = PdfReportService;
    window.PdfReportService = PdfReportService;
}
